
//export const base_url = 'http://localhost:3000/'; 
export const base_url = 'https://ccme.ae/'; 
//export const base_url = 'https://ccme.ae/'; 
//export const api_base_url = 'https://ccme.ae/admin/public/api/'; 
export const api_base_url = 'https://ccme.ae/admin/public/api/'; 
 